import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom'; // Import useLocation for route tracking
import { useLocalStorage, useMediaQuery } from 'usehooks-ts';

import Navbar from '@/components/common/Navbar';
import Sidebar from '@/components/common/Sidebar';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useAuth } from '@/context/CoginitoAuthProvider';

export function DashboardLayout({ children }: { children?: React.ReactNode }) {
  const { dbUser } = useAuth();

  const [navOpen, setNavOpen] = useState(true);
  const [, setSideOpen] = useState(true);
  const [recentPages, setRecentPages] = useLocalStorage<string[]>(
    'recent-pages',
    [],
  );
  const location = useLocation();
  const isMatches = useMediaQuery('(min-width: 1080px)');

  // Track the recent page visits
  useEffect(() => {
    const currentPath = location.pathname;

    // Only add the page if it's not the same as the last visited
    if (recentPages[0] !== currentPath) {
      const updatedPages = [currentPath, ...recentPages].slice(0, 5); // Ensure only 5 items
      setRecentPages(updatedPages);
    }
  }, [location, recentPages, setRecentPages]); // Trigger on location (route) change

  useEffect(() => {
    if (!isMatches) {
      setNavOpen(false);
      setSideOpen(false);
    }
  }, [isMatches]);

  if (!dbUser) {
    return <Navigate to="/sign-in" />;
  }

  return (
    <main
      className={clsx(
        'relative max-w-screen min-h-screen overflow-hidden flex bg-white text-black transition-all duration-300',
      )}
    >
      <div
        className={clsx(
          'h-screen w-[260px] min-w-[260px] -ml-[260px] border-r border-white/10 transition-all duration-300 z-20',
          {
            '!ml-0': navOpen,
          },
        )}
      >
        <Sidebar />
      </div>

      <div className="relative flex-1 min-w-[416px] flex flex-col min-h-screen">
        <Navbar setSideOpen={setSideOpen} setNavOpen={setNavOpen} />
        {/* <ScrollArea className="h-[calc(100vh-64px)] bg-zinc-50 overflow-[unset]"> */}
        <TooltipProvider>{children ?? <Outlet />}</TooltipProvider>
        {/* </ScrollArea> */}
      </div>
    </main>
  );
}
